<template>
  <div>
    <div class="card table">
      <div class="table-title">
        <div class="title">{{ tableCardTitle }}</div>
        <a-table
          style="margin-top:20px;"
          :dataSource="data"
          :columns="columns"
          :pagination="localPagination"
          :loading="loading"
          @change="changeData"
          v-bind="$attrs"
          :scroll="scroll"
          :bordered="bordered"
          :rowKey="rowKey"
        >
          <!-- 自定义列头渲染项 -->
          <template v-for="colCustom in columnsSlots" :slot="colCustom.title">
            <slot :name="colCustom.title"></slot>
          </template>
          <!-- 自定义列内容渲染项 -->
          <template
            v-for="colCustom in columnsCustom"
            :slot="colCustom.customRender"
            slot-scope="text, record, index"
          >
            <slot
              :name="colCustom.customRender"
              :tableRow="record"
              :index="index"
              :text="text"
              v-bind:item="text"
            ></slot>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TableView',
  props: {
    bordered: {
      type: Boolean,
      required: false,
      default: false,
    },
    tableCardTitle: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    data: {
      type: Array,
      required: true, // 必传
    },
    columns: Array,
    pagination: {
      type: [Object, Boolean],
      default: () => ({
        total: 0,
        pageSize: 15,
        current: 1,
      }),
    },
    fetchData: {
      type: Function,
    },
    //是否可以改变pageSize
    showSizeChanger: {
      type: Boolean,
      default: true,
    },
    //是否可以快速跳转至某页
    showQuickJumper: {
      type: Boolean,
      default: true,
    },
    scroll: {
      type: Object,
    },
    rowKey: {
      type: String,
      default: () => {
        return 'id'
      },
    },
  },
  computed: {
    columnsSlots() {
      return this.columns
        .filter(item => {
          return item.slots
        })
        .map(item => item.slots)
    },
    columnsCustom() {
      return this.columns
        .filter(item => {
          return item.scopedSlots
        })
        .map(item => item.scopedSlots)
    },

    localPagination() {
      return typeof this.pagination === 'object'
        ? Object.assign(
            {},
            {
              ...this.pagination,
              showSizeChanger: this.showSizeChanger,
              showQuickJumper: this.showQuickJumper,
            },
          )
        : this.pagination
    },
  },
  methods: {
    // 加载数据——切换页数、跳转页、切换每页条数时调用
    changeData(pagination = this.localPagination) {
      this.$emit('handlePagination', pagination)
    },
  },
}
</script>
<style lang="less" scoped>
.table {
  .title {
    color: #3a3f63;
    line-height: 24px;
    font-weight: 700;
  }
}
</style>
